import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
const Cryptos = () => {
  return <div></div>;
};

export default Cryptos;
